<script lang="ts">
	import { _ } from 'svelte-i18n';
	import DefaultButton from '../buttons/DefaultButton.svelte';
	import Modal from '../modal/Modal.svelte';
	import ModalHeader from '../modal/ModalHeader.svelte';
	import { confirmState } from './ConfirmStore';
	import DefaultTextInput from '../input/DefaultTextInput.svelte';

	//Text used to check if same as requested
	let deleteInput: string = $state('');

	function resetState() {
		$confirmState = null;
		deleteInput = '';
	}
</script>

{#if $confirmState}
	<Modal
		onModalClose={() => {
			if ($confirmState?.declineCallback) {
				$confirmState.declineCallback();
			}
			$confirmState = null;
		}}
	>
		{#snippet header()}
			<div>
				<ModalHeader text={$_('general.lbl_confirm_dialog_header')} />
			</div>
		{/snippet}

		{#snippet content()}
			<div>
				<!--Show a warning text-->
				{#if $confirmState?.warningText}
					<p
						style="max-width: 860px;"
						class="p-2 text-red dark:text-orange font-bold whitespace-pre-line"
					>
						{$confirmState.warningText}
					</p>
				{/if}

				<p class="p-2 whitespace-pre-wrap" style="max-width: 860px;">{$confirmState?.bodyText}</p>

				{#if $confirmState?.securityCheckText}
					<DefaultTextInput
						propertyName=""
						placeholder={$confirmState.securityCheckText}
						bind:value={deleteInput}
						focusOnStart={true}
					/>
				{/if}
			</div>
		{/snippet}
		{#snippet footer()}
			<div>
				<!-- Buttons-->
				<div class="flex justify-end gap-4">
					<DefaultButton
						secondary={true}
						onClick={() => {
							if ($confirmState?.declineCallback) {
								$confirmState.declineCallback();
							}
							//Hide the store dialog again
							resetState();
						}}
						text={$confirmState?.declineButtonText
							? $confirmState.declineButtonText
							: $_('general.lbl_cancel')}
					/>

					{#if $confirmState?.alternativeOptionButtonText}
						<DefaultButton
							onClick={() => {
								if ($confirmState?.alternativeOptionCallback) {
									$confirmState.alternativeOptionCallback();
								}
								//Hide the store dialog again
								resetState();
							}}
							text={$confirmState.alternativeOptionButtonText}
						/>
					{/if}

					<DefaultButton
						warning={$confirmState?.warningText != null}
						disabled={$confirmState?.securityCheckText
							? !($confirmState.securityCheckText === deleteInput)
							: false}
						onClick={() => {
							$confirmState?.successCallback();
							//Hide the store dialog again
							resetState();
						}}
						text={$confirmState?.acceptButtonText
							? $confirmState.acceptButtonText
							: $_('general.lbl_accept')}
					/>
				</div>
			</div>
		{/snippet}
	</Modal>
{/if}
